import PropTypes from 'prop-types';
import React from 'react'
import RadioGroup from 'react-radio-group'

import Interests from '~/components/Interests/Toggle'

import { toggleInterests } from '~/actions/interests'


export default class extends React.Component {
    static propTypes = {
		dispatch: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		interests: PropTypes.array.isRequired,
		userInterests: PropTypes.array.isRequired
	};

    state = {
        completed: this.props.userInterests.length >= 3
    };

    changeInterest = (newInterests) => {
		this.setState({
			completed: newInterests.length >= 3
		});
	};

    render() {

		return (

			<div>
				<div className="slide-wrapper">
					<header className="bg-deep-main ptop20 pbot20">
						<h4 className="text-white text-center mtop0 mbot0">What do you want to learn more about?</h4>
					</header>
					<div className="inner bg-light-main bg-slightly-transparent p20 interestBoxGrid">
						<p className="text-center text-white mbot15" style={{width: '100%'}}>We've pre-selected a few to get you started</p>
	                	<Interests 	dispatch={this.props.dispatch} 
	                				userInterests={this.props.userInterests} 
	                				interests={this.props.interests}
	                				changeInterest={this.changeInterest}  />
		                <div className="clearfix"></div>
					</div>
					<footer className="bg-deep-main p20">
						<p className="lead mbot0 text-center text-white">
							<i className="icon icon-chevron-left pull-left clickable" onClick={this.props.prevSlide}></i>
							{ this.state.completed ? 'Continue' : 'Pick 3 to continue' }
							<i 	className={"icon icon-chevron-right pull-right clickable " + (!this.state.completed ? "text-dark-gray" : "")}
								onClick={this.state.completed ? this.props.nextSlide : false}></i>
						</p>
						<div className="clearfix"></div>
					</footer>

				</div>

			</div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/InterestsSlide.jsx